import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DataLoadingErrorProps {
  message?: string;
  onRetry?: () => void;
}

export default function DataLoadingError({
  message = 'Something went wrong loading this content.',
  onRetry,
}: DataLoadingErrorProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <AlertTriangle className="w-10 h-10 text-destructive mb-4" />
      <p className="text-lg font-medium text-foreground mb-2">Unable to load</p>
      <p className="text-muted-foreground mb-6 max-w-md">{message}</p>
      {onRetry && (
        <Button variant="outline" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}
